import {EventEmitter, Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';
import {UtilitiesService} from "./utilities.service";
import {Router} from "@angular/router";

Injectable({
  providedIn: 'root'
})

@Injectable()
export class CoreService {
  constructor(private router: Router) {
  }

  public isManualNavigation: boolean = false;
  public blockRoutes: boolean = false;
  public backButtonClicked = new EventEmitter<boolean>();
  public brandNameSubject: BehaviorSubject<string> = new BehaviorSubject<string>("");
  public canAccessSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public pagePropsSubject: BehaviorSubject<PageProps> = new BehaviorSubject<PageProps>(new PageProps());
  public brandName: Observable<string> = this.brandNameSubject.asObservable();
  public isDataLoaded: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  setBrand(name: string) {
    return this.brandNameSubject.next(name);
  }

  setPageProps(props: PageProps) {
    return this.pagePropsSubject.next(props);
  }

  setCanAccess(canAccess: boolean) {
    return this.canAccessSubject.next(canAccess);
  }

  navigate(path: string) {
    this.blockRoutes = false;
    UtilitiesService.canRouteInternal = true;
    this.router.navigate([`${path}`]);
  }

  disableBackButton() {
    this.blockRoutes = true;
  }
}

export class PageProps {
  isHomePage: boolean | null = null;
  title: string | null = null;
}
